$(document).ready(function () {
  $(".slider-for").each(function (key, item) {
    let sliderIdName = "slider" + key;

    this.id = sliderIdName;

    let sliderId = "#" + sliderIdName;

    $(sliderId).slick({
      dots: true,
      infinite: true,
      speed: 500,
      fade: true,
      cssEase: "linear",
      adaptiveHeight: true,
      autoplay: true,
      prevArrow: '<div class="prev-arrow"></div>',
      nextArrow: '<div class="next-arrow"></div>',
    });
  });
});
